import React, { Component } from "react";
import { connect } from "react-redux";

//import classes from "./Layout.css";
// import "./Layout.css";
import * as actions from "../../store/actions/index";
import Aux from "../AuxFolder/reactaux";
import Toolbar from "../../components/Navigation/Toolbar/Toolbar";
//import SideDrawer from "../../components/Navigation/SideDrawer/SideDrawer";
import { doLog } from "../../shared/utility";

class Layout extends Component {
  state = {
    showSideDrawer: false,
  };

  componentDidMount() {
    if (doLog()) console.log("[Layout] componentDidMount");
  }

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState((prevState) => {
      return { showSideDrawer: !prevState.showSideDrawer };
    });
  };

  render() {
    if (doLog()) console.log("[Layout] render");
    if (doLog()) console.log("[Layout] render props:", this.props);
    let layoutClass = "Layout FullHeight";
    if (doLog()) console.log("[Layout] render children:", this.props.children);
    if (doLog()) console.log("[Layout] render agencyCode:", this.props.agencyCode);

    return (
      <Aux>
        <Toolbar
          isAuth={this.props.isAuthenticated}
          drawerToggleClicked={this.sideDrawerToggleHandler}
          configuration={this.props.configuration}
          baseURL={this.props.baseURL}
          pathname={this.props.pathname}
          agencyCode={this.props.agencyCode}
        />
        {/* <SideDrawer
          isAuth={this.props.isAuthenticated}
          open={this.state.showSideDrawer}
          closed={this.sideDrawerClosedHandler}
        /> */}
        {/* <div className={[classes.Layout, classes.FullHeight].join(" ")}> */}
        <div className={layoutClass}>{this.props.children}</div>
      </Aux>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    configuration: state.trans.configuration,
    baseURL: state.trans.baseURL,
    pathname: state.trans.pathname,
    agencyCode: state.trans.agencyCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchConfiguration: (token, agencyCode) => dispatch(actions.fetchConfiguration(token, agencyCode)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);

